"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.createIdea = createIdea;
const path = __importStar(require("path"));
const dist_1 = require("../../core/dist");
const dist_2 = require("../../core/dist");
const dist_3 = require("../../core/dist");
const resolveThreadFolder_1 = require("./utils/resolveThreadFolder");
async function createIdea(input, deps) {
    const weaveName = input.weaveSlug || (0, dist_1.toKebabCaseId)(input.title);
    // Invariant: every doc lives in a thread, referenced by its stable th_ ULID.
    // Weave-root idea creation is retired — a thread_ulid is required.
    if (!input.threadUlid) {
        throw new Error('Cannot create an idea: a thread_ulid is required. Create the thread first (createThread) and pass its returned thread_ulid.');
    }
    // Resolve the thread by its stable ULID → folder. Never fabricates: an unknown
    // thread_ulid throws (createThread is the only way to make a thread).
    const { threadPath } = await (0, resolveThreadFolder_1.resolveThreadFolder)(weaveName, input.threadUlid, deps);
    const id = (0, dist_1.generateDocId)('idea');
    const frontmatter = (0, dist_2.createBaseFrontmatter)('idea', id, input.title);
    const content = input.content ?? (0, dist_3.generateIdeaBody)(input.title);
    const doc = { ...frontmatter, content };
    const filePath = path.join(threadPath, (0, dist_1.singletonFileName)('idea'));
    await deps.saveDoc(doc, filePath);
    return { id, filePath };
}
